export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'この画面ではデジタコから日報が作成できます。<br>登録までのガイドが必要な場合は[次へ]を押してください。<br>すぐに始める場合は[操作ガイド終了]を押してください。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ]
})
